
























































































import { Component, Vue, Prop } from 'vue-property-decorator';

import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';
import TypeBox from '@/components/TypeBox/TypeBox.vue';
import { TextField } from '@/components/atoms';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import {
  CustomersList,
  TransactionsList,
  NewCustomersList
} from '@/components/organisms/BusinessDetail';
import ResumeCard from '@/componentsV2/molecules/ResumeCard/ResumeCard.vue';
import AdminTabs from '@/componentsV2/molecules/AdminTabs/AdminTabs.vue';

import TwismWalletBillingActivity from './TwismWalletBillingActivity.vue';
import TwismWalletSendCoinsHistory from './TwismWalletSendCoinsHistory.vue';
import { FilledButton } from '@/components/molecules';
import eventBus from '@/utils/eventBus';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { formatString, toNumber } from '@/utils/moneyTreatments';
import flagKeys from '@/constants/flagKeys';
import DateUtils from '@/utils/DateUtils';
import AdminService from '@/api/AdminService';
import { sleep } from '@/utils';

@Component({
  components: {
    TextField,
    SideModalHeader,
    TypeBox,
    CustomersList,
    TransactionsList,
    NewCustomersList,
    Checkbox,
    ResumeCard,
    AdminTabs,
    TwismWalletBillingActivity,
    TwismWalletSendCoinsHistory,
    FilledButton,
    Typography
  }
})
export default class TwismWalletDetail extends Vue {
  @Prop({ required: true }) data!: any;

  delayedLoading = false;

  service: AdminService = new AdminService();

  mintingStartDate = this.data.mitingStartDate;
  activeTabKey = 'billing-activity';

  get tabMapper() {
    return {
      'billing-activity': {
        label: 'Billing Activity',
        component: 'TwismWalletBillingActivity',
        componentProps: {
          businessId: this.data.id
        }
      },
      'send-coins-history': {
        label: 'Send Coins History',
        component: 'TwismWalletSendCoinsHistory',
        componentProps: {
          businessId: this.data.id
        }
      }
    };
  }

  get disabledSendCoins() {
    return toNumber(this.data.coins) === 0 || !this.twismWalletSendCoins;
  }

  get disabledSendCoinsToCoinStore() {
    return (
      (toNumber(this.data.coins) === 0 &&
        this.data.subscriptionStatus == 'inactive') ||
      !this.coinsStoreEnabled
    );
  }

  get tabs() {
    return Object.entries(this.tabMapper).map(([key, value]) => ({
      key,
      label: value.label
    }));
  }

  get subscriptionActivated() {
    return this.data.subscriptionStatus === 'active';
  }

  get getPicture() {
    try {
      if (!this.data.picture.includes('https')) return '';
      return {
        background: `url('${this.data.picture}')`,
        backgroundSize: 'cover'
      };
    } catch (e) {
      return 'hasNoImage';
    }
  }

  get enableEditDelayedPeriod() {
    return (
      this.flags.includes(flagKeys.billingModuleV3) &&
      this.data.mitingStartDate &&
      this.isDelayedSubscription
    );
  }

  get resumeData() {
    return {
      title: 'Lifetime Reports',
      list: [
        {
          label: 'Coins minted for Twism',
          value: this.getNumber(this.data.lifetimeCoins || '0')
        },
        {
          label: 'Coins available',
          value: this.getNumber(this.data.coins || '0')
        },
        { label: 'Locations', value: this.data.locations || '1' },
        {
          label: 'Active billing day',
          value:
            this.subscriptionActivated && this.data.subscriptionPaymentDay
              ? `every ${this.data.subscriptionPaymentDay}`
              : '-'
        }
      ]
    };
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get billingMinDate() {
    return DateUtils.addDays(new Date(this.data.subscriptionCreatedAt), 7);
  }

  get twismWalletSendCoins() {
    return this.flags.includes(flagKeys.twismWalletSendCoins);
  }

  get coinsStoreEnabled() {
    return this.flags.includes(flagKeys.coinStoreV1);
  }

  get isDelayedSubscription() {
    if (!this.data.mitingStartDate) return false;
    return new Date() <= new Date(this.data.mitingStartDate);
  }

  handleUpdateMintingDate(date: string) {
    this.mintingStartDate = date;
  }

  async handleChangeMitingStartDate() {
    try {
      const date = new Date(this.mintingStartDate);
      date.setHours(0);
      date.setDate(date.getDate() - 1);
      this.delayedLoading = true;
      await this.service.setBillingDelayedPeriod(
        this.data.id,
        date.toISOString().split('T')[0]
      );
      eventBus.$emit('reloadTwismWallet', false);
    } finally {
      await sleep(2000);
      this.delayedLoading = false;
    }
  }

  getNumber(str: string) {
    return formatString(str);
  }

  getDate(date: string) {
    return DateUtils.formattedDate({
      date
    });
  }

  openSendCoinsModal(customer: boolean = false) {
    const modalConfig = {
      isOpen: true,
      component: 'adminTwismWalletDetails',
      data: { ...this.data, close: this.closeSendCoinsModal },
      width: '750px',
      subModal: {
        isOpen: true,
        component: customer
          ? 'adminTwismWalletSendCoins'
          : 'adminCoinStoreSendCoins'
      }
    };
    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  closeSendCoinsModal() {
    const modalConfig = {
      isOpen: true,
      component: 'adminTwismWalletDetails',
      data: this.data,
      width: '750px'
    };
    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  handleTabChanges(tabKey: string) {
    this.activeTabKey = tabKey;
  }

  created() {
    if (!this.data.notReload) eventBus.$emit('reloadTwismWallet', false);
  }
}
